import React from "react";
import { useLocation ,Link} from "react-router-dom";
import Navbar from "../components/Navbar";



const BlogMain = () => {
  const { state } = useLocation();
  const blog = state?.blog;

  if (!blog) {
    return <p>No blog data available.</p>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <main className="max-w-6xl mx-auto px-4 py-8 md:pt-30 pt-30 ">
        <article className="overflow-hidden">
          {/* Hero Section */}
          <div className="relative">
            <img
              src={blog.featured_image}
              alt={blog.title}
              className="w-full h-96 object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-6">
              <h1 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-2">
                {blog.title}
              </h1>
              <div className="flex items-center space-x-4 text-gray-300 text-sm">
                <span>{new Date(blog.published_date).toLocaleDateString()}</span>
                <span>•</span>
                <span>{blog.author}</span>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="p-8">
            <div className="max-w-3xl mx-auto" dangerouslySetInnerHTML={{ __html: blog.content }} />
          </div>

          {/* Back Button */}
          <div className="p-8 text-center">
            <Link
              to="/blogs"
              className="bg-teal-600 text-white px-6 py-2 rounded-lg hover:bg-teal-700 transition-colors shadow-sm relative group"
            >
              ← Back to Blogs
              <span className="absolute -inset-1 bg-teal-600 rounded-lg opacity-0 group-hover:opacity-5 transition-opacity"></span>
            </Link>
          </div>
        </article>
      </main>
    </div>
  );
};

export default BlogMain;
